<h2 class="td-wb-call-out-header" [attr.aria-level]="ariaLevel()"><ng-content /></h2>